/**
 * CustomerLayout Component
 *
 * Description: This component provides a layout for customer-related pages. It includes a header and a sidebar, with conditional rendering based on the current route. If the route is not included in the `exceptSidebar` array, both the header and sidebar are displayed; otherwise, only the content (`children`) is shown.
 *
 * Props:
 * - children (ReactNode): The content to be rendered inside the layout. This typically includes the page-specific components or elements.
 *
 * File Name: CustomerLayout.tsx
 * Date: 12-08-2024
 */

import React, { ReactNode } from "react";
import CustomerHeader from "src/Components/Customer/CustomerHeader";
import CustomerSidebar from "src/Components/Customer/CustomerSidebar";
import DiagnosticCartModal from "src/Components/DiagnosticCartModal";
import { useLocation } from "react-router-dom";
import WebGlobalSearch from "src/Components/WebsiteComponents/WebGlobalSearch";
interface ICustomerLayoutProps {
  children: ReactNode;
}

const CustomerLayout: React.FC<ICustomerLayoutProps> = ({ children }) => {
  const exceptSidebar: string[] = [
    "/profile-view",
    "/patient-public/:id/profile",
    "/checkout-payment",
    "/doctor-public-profile/:id/view",
    "/doctor-public-profile",
    "/customer/diagnostic-product-detail/:type/:id/view",
    "/doctor/homecareservices/:id/view",
    "/customer/pharmacy-product-detail/:id/view",
    "/doctor/homecareservices",
    "/customer/diagnostic-products",
    "/customer/pharmacy-products",
    "/scheduler",
    "/patient-public/",
    "/customer/pharmacy-cart",
    "/customer/pharmacy-checkout",
    "/customer/diagnostic-cart",
    "/customer/diagnostic-checkout",
    "/customer/:id/:appointmentDate/:daySlot/homecare-checkout",
    "/find-doctors",
  ];
  const { pathname } = useLocation();
  // Function to check if current path matches any path in exceptSidebar
  const isExcludedPath = () => {
    return exceptSidebar.some((excludedPath) => {
      // const pathPattern = excludedPath.replace(':id', '[a-fA-F0-9]{24}');
      const pathPattern = excludedPath
        .replace(":type", "[a-zA-Z]+") // Match the :type placeholder (assuming it's alphabetic)
        .replace(":id", "[a-fA-F0-9]{24}")
        .replace(
          ":appointmentDate",
          "\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{3}Z"
        )
        .replace(":daySlot", "[a-zA-Z]+");
      const regex = new RegExp(`^${pathPattern}$`);
      return regex.test(pathname);
    });
  };
  return (
    <div className=" dashboards bg-[#F4F2EE]">
      <CustomerHeader />

      <div className="mt-[4.5vw]">
        <>
          {isExcludedPath() ? (
            children
          ) : (
            <div className="view-area-width-2 h-3vw flex justify-between">
            {/* <div className="container-1480 h-3vw flex justify-between"> */}
              <CustomerSidebar />
              <section
                className={`${
                  window.location.href.includes("/dashboard")
                    ? "admin-right-side-none"
                    : ""
                } customer-sidebar-second-box-width`}
                // } admin-right-side`}
              >
                {children}
              </section>
            </div>
          )}
        </>
      </div>
      <DiagnosticCartModal layout="dashboard" />
    </div>
  );
};

export default CustomerLayout;
